import React from 'react'
import cn from 'classnames'
import { useIntl } from 'react-intl'
import styles from './app-store-button.module.scss'

interface AppStoreButtonProps {
  onClick?: () => void
  buttonImg: string
}

export const AppStoreButton: React.FC<AppStoreButtonProps> = (props) => {
  const intl = useIntl()
  return (
    <button className={cn(styles.base, styles.appStoreBtn)} onClick={props.onClick} data-qa="btnStore">
      <img
        className={cn(styles.base, styles.appStoreBtn)}
        src={props.buttonImg}
        height={44}
        alt={intl.formatMessage({
          id: 'ctaButton.appStoreButton.altText',
          description: 'CTA Button - App Store Button - Alt Text',
          defaultMessage: 'App Store Download',
        })}
      />
    </button>
  )
}
